// What the Select offers, and what "Auto" resolves to when the page is left to work it out. The value is the
// character itself rather than a name for it, so nothing has to look one up to split a line with.
export const AUTO = "auto";

export const DELIMITERS = [
  { value: AUTO, label: "Auto" },
  { value: ",", label: "Comma" },
  { value: ";", label: "Semicolon" },
  { value: "\t", label: "Tab" },
  { value: "|", label: "Pipe" },
  { value: ":", label: "Colon" },
] as const satisfies readonly Delimiter[];

// The four a file is sniffed against. The colon is offered and never guessed: a clock reads as three fields under it,
// consistently enough down a column of timestamps to beat the comma that actually separates them.
export const CANDIDATES = [",", ";", "\t", "|"];

export type DelimiterId = typeof DELIMITERS[number]["value"];

interface Delimiter {
  value: string;
  label: string;
}

export function isDelimiter(value: string | null | undefined): value is DelimiterId {
  return DELIMITERS.some((entry) => entry.value === value);
}

// What the summary calls the character the fields were split on: a tab and a space are the same picture otherwise.
export function delimiterLabel(delimiter: string): string {
  return DELIMITERS.find((entry) => entry.value === delimiter)?.label ?? delimiter;
}
